import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Volume2 } from "lucide-react";
import { api } from "@/lib/api";

// Public list of admin-created prayers spoken in Charles's own (cloned) voice.
export const SpokenPrayers = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api
      .get("/spoken-prayers")
      .then((r) => setItems(r.data || []))
      .catch(() => {});
  }, []);

  if (!items.length) return null;

  return (
    <div data-testid="spoken-prayers-list" className="mt-20 max-w-3xl mx-auto text-left">
      <h3 className="text-center font-mono text-xs uppercase tracking-[0.3em] text-gold-light mb-8">
        Spoken Prayers · In His Voice
      </h3>
      <div className="space-y-4">
        {items.map((p) => (
          <motion.div
            key={p.id}
            data-testid={`spoken-prayer-${p.id}`}
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="rounded-2xl border border-gold/20 bg-parchment/[0.04] backdrop-blur-sm p-5"
          >
            <div className="flex items-center gap-2 mb-3">
              <Volume2 size={16} className="text-gold-light" />
              <span className="font-serif text-lg text-parchment">{p.title}</span>
            </div>
            {p.video_url ? (
              <video
                src={p.video_url}
                controls
                playsInline
                data-testid={`spoken-video-${p.id}`}
                className="w-full rounded-xl bg-ink"
              />
            ) : (
              <audio
                src={p.audio_url}
                controls
                data-testid={`spoken-audio-${p.id}`}
                className="w-full"
              />
            )}
            {p.text && (
              <p className="mt-3 text-sm text-parchment/65 whitespace-pre-wrap line-clamp-4">
                {p.text}
              </p>
            )}
          </motion.div>
        ))}
      </div>
    </div>
  );
};
